// @ts-nocheck
if (!customElements.get('image-canvas-simulation')) {
  class ImageCanvasSimulation extends HTMLElement {
    constructor() {
      super();
      this.ctx = null;
      this.currentImageData = null;
      this.uploadedImage = null;
      this.imageBounds = null;
    }

    connectedCallback() {
      this.canvas = this.querySelector('.paint-canvas');
      this.borderOptionsLabel = document.querySelector('[data-option-handle="border-options"] legend');
      this.borderOptionProperty = document.querySelector('[ref="border_option"]');
      this.ctx = this.canvas.getContext('2d', { willReadFrequently: true });
      
      this.onCanvasImageUploadedUnsubscriber = subscribe(
          PUB_SUB_EVENTS.canvasImageUploaded,
          this.repopulateCanvas.bind(this)
      );

      this.onVariantIdChangedUnsubscriber = subscribe(
          PUB_SUB_EVENTS.variantIdChanged,
          this._variantIdChanged.bind(this)
      );
    }
    
    repopulateCanvas({ data: { result, orientation } }) {
      if (!this.dataset.imageSrc.includes(orientation)) return;

      const { width, height } = this.canvas;

      // RESET CANVAS
      this.ctx.save();
      this.ctx.setTransform(1, 0, 0, 1, 0, 0);
      this.ctx.clearRect(0, 0, width, height);
      // **FORCE NO SMOOTHING GLOBALLY**
      this.ctx.imageSmoothingEnabled = false;
      this.ctx.mozImageSmoothingEnabled = false;
      this.ctx.webkitImageSmoothingEnabled = false;
      this.ctx.msImageSmoothingEnabled = false;
      this.ctx.imageSmoothingQuality = 'low';
      this.ctx.restore();

      this.ctx.fillStyle = 'rgba(0,0,0,0)';
      this.ctx.fillRect(0, 0, width, height);

      // LOAD TEMPLATE IMAGE
      const templateImage = new Image();
      templateImage.crossOrigin = "anonymous";
      templateImage.src = this.dataset.imageSrc;

      templateImage.onload = () => {
        // MASK SCANNING
        const maskCanvas = document.createElement('canvas');
        maskCanvas.width = width;
        maskCanvas.height = height;
        const maskCtx = maskCanvas.getContext('2d', { willReadFrequently: true });
        maskCtx.drawImage(templateImage, 0, 0, width, height);
        const maskData = maskCtx.getImageData(0, 0, width, height);
        const maskPixels = maskData.data;

        // BOUNDING BOX SCAN
        let minX = width, minY = height, maxX = 0, maxY = 0;
        for (let y = 0; y < height; y++) {
          for (let x = 0; x < width; x++) {
            const idx = (y * width + x) * 4 + 3;
            const alpha = maskPixels[idx];
            if (alpha < 10) {
              if (x < minX) minX = x;
              if (x > maxX) maxX = x;
              if (y < minY) minY = y;
              if (y > maxY) maxY = y;
            }
          }
        }

        this.imageBounds = { minX, maxX, minY, maxY };
        
        if (minX >= maxX || minY >= maxY) {
          this.ctx.drawImage(templateImage, 0, 0, width, height);
          return;
        }

        // LOAD UPLOADED IMAGE
        this.uploadedImage = new Image();
        this.uploadedImage.crossOrigin = "anonymous";
        this.uploadedImage.src = result;

        this.uploadedImage.onload = () => {
          const img = this.uploadedImage;
          // QUADRILATERAL COORDINATES
          let TL = null;
          let TR = null;
          let BR = null;
          let BL = null;

          if(this.dataset.imageSrc.includes('straight-edged')) {
            TL = { x: minX - 2, y: minY - 2 };
            TR = { x: maxX + 2, y: minY - 2 };
            BR = { x: maxX + 2, y: maxY + 2 };
            BL = { x: minX - 2, y: maxY + 2 };
          } else {
            TL = this.dataset.position === 'main' ? { x: minX - 2, y: minY - 8 } : { x: minX - 1, y: minY - 1 };
            TR = this.dataset.position === 'main' ? { x: maxX + 2, y: minY + 14 } : { x: maxX + 2, y: minY + 3 };
            BR = this.dataset.position === 'main' && !this.dataset.imageSrc.includes('panoramic') ? { x: maxX + 2, y: maxY - 19 } : this.dataset.position === 'main' && this.dataset.imageSrc.includes('panoramic') ? { x: maxX + 2, y: maxY - 18 } : { x: maxX + 1, y: maxY - 3 };
            BL = this.dataset.position === 'main' ? { x: minX - 2, y: maxY + 4 } : { x: minX - 1, y: maxY + 1 };
          }
          // CREATE 3x3 GRID (4 inner points)
          const P1 = { x: (TL.x + TR.x) / 2, y: (TL.y + TR.y) / 2 }; // top-middle
          const P2 = { x: (BL.x + BR.x) / 2, y: (BL.y + BR.y) / 2 }; // bottom-middle
          const P3 = { x: (TL.x + BL.x) / 2, y: (TL.y + BL.y) / 2 }; // left-middle
          const P4 = { x: (TR.x + BR.x) / 2, y: (TR.y + BR.y) / 2 }; // right-middle
          const center = { x: (TL.x + TR.x + BR.x + BL.x) / 4, y: (TL.y + TR.y + BR.y + BL.y) / 4 };

          // CLEAR CANVAS
          this.ctx.clearRect(0, 0, width, height);
          if(this.dataset.position === 'main') {
          // CREATE 6x6 GRID POINTS (5x5 inner grid = 50 triangles)
          const gridPoints = [];

          for (let row = 0; row <= 5; row++) {
            for (let col = 0; col <= 5; col++) {
              const srcX = (img.width / 5) * col;
              const srcY = (img.height / 5) * row;
              
              const t = row / 5;
              const s = col / 5;
              
              const topX = TL.x + (TR.x - TL.x) * s;
              const topY = TL.y + (TR.y - TL.y) * s;
              const bottomX = BL.x + (BR.x - BL.x) * s;
              const bottomY = BL.y + (BR.y - BL.y) * s;
              
              const dstX = topX + (bottomX - topX) * t;
              const dstY = topY + (bottomY - topY) * t;
              
              gridPoints.push({ 
                srcX: Math.round(srcX), 
                srcY: Math.round(srcY), 
                dstX: Math.round(dstX), 
                dstY: Math.round(dstY) 
              });
            }
          }

          // GENERATE 50 TRIANGLES (2 triangles per grid cell)
          const triangles = [];
          for (let row = 0; row < 5; row++) {
            for (let col = 0; col < 5; col++) {
              const idx = row * 6 + col;
              
              // Triangle 1: top-left, top-right, bottom-left
              triangles.push({
                src: [
                  gridPoints[idx].srcX, gridPoints[idx].srcY,
                  gridPoints[idx + 1].srcX, gridPoints[idx + 1].srcY,
                  gridPoints[idx + 6].srcX, gridPoints[idx + 6].srcY
                ],
                dst: [
                  gridPoints[idx].dstX, gridPoints[idx].dstY,
                  gridPoints[idx + 1].dstX, gridPoints[idx + 1].dstY,
                  gridPoints[idx + 6].dstX, gridPoints[idx + 6].dstY
                ]
              });
              
              // Triangle 2: top-right, bottom-right, bottom-left
              triangles.push({
                src: [
                  gridPoints[idx + 1].srcX, gridPoints[idx + 1].srcY,
                  gridPoints[idx + 7].srcX, gridPoints[idx + 7].srcY,
                  gridPoints[idx + 6].srcX, gridPoints[idx + 6].srcY
                ],
                dst: [
                  gridPoints[idx + 1].dstX, gridPoints[idx + 1].dstY,
                  gridPoints[idx + 7].dstX, gridPoints[idx + 7].dstY,
                  gridPoints[idx + 6].dstX, gridPoints[idx + 6].dstY
                ]
              });
            }
          }

          // DRAW ALL TRIANGLES
          this.ctx.imageSmoothingEnabled = false;
          this.ctx.imageSmoothingQuality = 'low'; // Use 'low' for sharper edges
          triangles.forEach(tri => {
            this.drawTriangleWarp(
              this.ctx, img,
              ...tri.src,
              ...tri.dst
            );
          });
        } else {
          // ----------------------------------------
          // DRAW 8 TRIANGLES
          // ----------------------------------------
          const triangles = [
            // Top-left quadrant
            { src: [0,0, img.width/2,0, 0,img.height/2], dst: [TL.x,TL.y, P1.x,P1.y, P3.x,P3.y] },
            { src: [img.width/2,0, img.width/2,img.height/2, 0,img.height/2], dst: [P1.x,P1.y, center.x,center.y, P3.x,P3.y] },

            // Top-right quadrant
            { src: [img.width/2,0, img.width,0, img.width/2,img.height/2], dst: [P1.x,P1.y, TR.x,TR.y, center.x,center.y] },
            { src: [img.width,0, img.width,img.height/2, img.width/2,img.height/2], dst: [TR.x,TR.y, P4.x,P4.y, center.x,center.y] },

            // Bottom-left quadrant
            { src: [0,img.height/2, img.width/2,img.height/2, 0,img.height], dst: [P3.x,P3.y, center.x,center.y, BL.x,BL.y] },
            { src: [img.width/2,img.height/2, img.width/2,img.height, 0,img.height], dst: [center.x,center.y, P2.x,P2.y, BL.x,BL.y] },

            // Bottom-right quadrant
            { src: [img.width/2,img.height/2, img.width,img.height/2, img.width/2,img.height], dst: [center.x,center.y, P4.x,P4.y, P2.x,P2.y] },
            { src: [img.width,img.height/2, img.width,img.height, img.width/2,img.height], dst: [P4.x,P4.y, BR.x,BR.y, P2.x,P2.y] },
          ];
          this.ctx.imageSmoothingEnabled = false;
          this.ctx.imageSmoothingQuality = 'low';
          triangles.forEach(tri => {
            this.drawTriangleWarp(
              this.ctx, img,
              ...tri.src,
              ...tri.dst
            );
          });
        }
          // DRAW TEMPLATE ON TOP
          this.ctx.drawImage(templateImage, 0, 0, width, height);

          // SAVE IMAGE DATA
          this.currentImageData = this.ctx.getImageData(0, 0, width, height);

          this.addBorderWrap(orientation);
        };
      };
    }

    drawTriangleWarp(ctx, img, 
      sx1, sy1, sx2, sy2, sx3, sy3, 
      dx1, dy1, dx2, dy2, dx3, dy3) {
      
      // Round coordinates
      dx1 = Math.round(dx1); dy1 = Math.round(dy1);
      dx2 = Math.round(dx2); dy2 = Math.round(dy2);
      dx3 = Math.round(dx3); dy3 = Math.round(dy3);
      
      ctx.save();

      // **ALTERNATIVE: Extend each edge outward by 1 pixel**
      ctx.beginPath();
      
      // Function to extend a point perpendicular to an edge
      const extendEdge = (x1, y1, x2, y2, x3, y3, distance = 1) => {
        // Calculate edge vector
        const edgeX = x2 - x1;
        const edgeY = y2 - y1;
        
        // Calculate perpendicular vector (pointing outward)
        const perpX = -edgeY;
        const perpY = edgeX;
        
        // Normalize
        const length = Math.sqrt(perpX * perpX + perpY * perpY);
        const normX = perpX / length;
        const normY = perpY / length;
        
        // Extend the third point (not on this edge) outward
        return {
          x: x3 + normX * distance,
          y: y3 + normY * distance
        };
      };
      
      // Extend each vertex
      const p1 = extendEdge(dx2, dy2, dx3, dy3, dx1, dy1, 1);
      const p2 = extendEdge(dx3, dy3, dx1, dy1, dx2, dy2, 1);
      const p3 = extendEdge(dx1, dy1, dx2, dy2, dx3, dy3, 1);
      
      ctx.moveTo(p1.x, p1.y);
      ctx.lineTo(p2.x, p2.y);
      ctx.lineTo(p3.x, p3.y);
      ctx.closePath();
      ctx.clip();

      // ... rest of your existing transform code
      const denom = (sx1*(sy2 - sy3) + sx2*(sy3 - sy1) + sx3*(sy1 - sy2));
      if (Math.abs(denom) < 1e-6) {
        ctx.drawImage(img, dx1, dy1);
        ctx.restore();
        return;
      }

      const a = (dx1*(sy2 - sy3) + dx2*(sy3 - sy1) + dx3*(sy1 - sy2)) / denom;
      const b = (dx1*(sx3 - sx2) + dx2*(sx1 - sx3) + dx3*(sx2 - sx1)) / denom;
      const c = (dx1*(sx2*sy3 - sx3*sy2) +
                dx2*(sx3*sy1 - sx1*sy3) +
                dx3*(sx1*sy2 - sx2*sy1)) / denom;

      const d = (dy1*(sy2 - sy3) + dy2*(sy3 - sy1) + dy3*(sy1 - sy2)) / denom;
      const e = (dy1*(sx3 - sx2) + dy2*(sx1 - sx3) + dy3*(sx2 - sx1)) / denom;
      const f = (dy1*(sx2*sy3 - sx3*sy2) +
                dy2*(sx3*sy1 - sx1*sy3) +
                dy3*(sx1*sy2 - sx2*sy1)) / denom;

      ctx.transform(a, d, b, e, c, f);
      ctx.imageSmoothingEnabled = false;
      
      ctx.drawImage(img, 0, 0);

      ctx.restore();
    }
    // UPDATED: Slanted border coordinates
    getBorderCoordinates() {
      if (!this.imageBounds) return null;
      const { minX, maxX, minY, maxY } = this.imageBounds;
      const borderWidth = 
      this.dataset.imageSrc.includes('square') && this.dataset.position.includes('main') ? 18 :
      !this.dataset.imageSrc.includes('square') && this.dataset.position.includes('main') ? 15 :
      this.dataset.imageSrc.includes('square') && this.dataset.position.includes('thumbnail') ? 6 :
      !this.dataset.imageSrc.includes('square') && this.dataset.position.includes('thumbnail') ? 4 : 14;
      return {
        // DIAGONAL SLANT - top-left ubos, top-right taas; bottom-left taas, bottom-right ubos
        topRight: { 
          x: minX - borderWidth,  // 20px gikan sa wala
          y: minY + 4       // Top-left mas UBOS
        },
        topLeft: { 
          x: minX + 1,      // Connect to image start
          y: minY + 1       // Top-right LEVEL sa image top
        },
        bottomRight: { 
          x: minX - borderWidth,  // 20px gikan sa wala
          y: maxY - 2       // Bottom-left mas TAAS
        },
        bottomLeft: { 
          x: minX + 1,      // Connect to image start
          y: maxY + 3       // Bottom-right LEVEL sa image bottom
        }
      };
    }

    addBorderWrap(orientation) {
      if(!this.dataset.imageSrc.includes('border-wrap') || !this.dataset.imageSrc.includes(orientation)) return;
      if (this.currentImageData) {
        this.ctx.putImageData(this.currentImageData, 0, 0);
      }
      if (this.uploadedImage) {
        this.addMirrorEffect(orientation);
      } else {
        this.drawSolidBorder();
      }

      this.currentImageData = this.ctx.getImageData(0, 0, this.canvas.width, this.canvas.height);
    }

    drawSolidBorder() {
      const coords = this.getBorderCoordinates();
      if (!coords) return; 
      this.ctx.fillStyle = '#000000';
      this.ctx.beginPath();
      this.ctx.moveTo(coords.topLeft.x, coords.topLeft.y);
      this.ctx.lineTo(coords.topRight.x, coords.topRight.y);
      this.ctx.lineTo(coords.bottomRight.x, coords.bottomRight.y);
      this.ctx.lineTo(coords.bottomLeft.x, coords.bottomLeft.y);
      this.ctx.closePath();
      this.ctx.fill();
    }

    // UPDATED: Mirror effect for slanted border
    addMirrorEffect(orientation) {
      if(!this.dataset.imageSrc.includes('border-wrap') || !this.uploadedImage || !this.dataset.imageSrc.includes(orientation)) return;
      
      if (this.currentImageData) {
        this.ctx.putImageData(this.currentImageData, 0, 0);
      }

      const { width, height } = this.canvas;
      const mirrorCanvas = document.createElement('canvas');
      mirrorCanvas.width = width;
      mirrorCanvas.height = height;
      const mirrorCtx = mirrorCanvas.getContext('2d');

      const coords = this.getBorderCoordinates();
      if (!coords) return;

      mirrorCtx.save();
      mirrorCtx.beginPath();
      mirrorCtx.moveTo(coords.topLeft.x, coords.topLeft.y);
      mirrorCtx.lineTo(coords.topRight.x, coords.topRight.y);
      mirrorCtx.lineTo(coords.bottomRight.x, coords.bottomRight.y);
      mirrorCtx.lineTo(coords.bottomLeft.x, coords.bottomLeft.y);
      mirrorCtx.closePath();
      mirrorCtx.clip();

      // USE TRIANGLE WARP FOR SLANTED IMAGE
      const mirrorTriangles = [
        {
          src: [0, 0, 20, 0, 0, this.uploadedImage.height],
          dst: [
            coords.topLeft.x, coords.topLeft.y - 10,                    // Top-right: original
            coords.topRight.x, coords.topRight.y - 10,            // ↑ Top-left 
            coords.bottomLeft.x, coords.bottomLeft.y - 2            // Top-middle: original
          ]
        },
        {
          src: [20, 0, 20, this.uploadedImage.height, 0, this.uploadedImage.height],
          dst: [
            coords.topRight.x, coords.topRight.y - 10,            // ↑ bottom-middle PASATAAS  
            coords.bottomRight.x, coords.bottomRight.y + 10,      // ↓ Bottom-left PAUBSON
            coords.bottomLeft.x, coords.bottomLeft.y - 2       //  Bottom right: original
          ]
        }
      ];

      mirrorCtx.scale(-1, 1); // Flip horizontally

      mirrorTriangles.forEach(tri => {
        // Adjust X coordinates for flip
        const flippedDst = tri.dst.map((val, index) => 
          index % 2 === 0 ? -val : val
        );
        
        this.drawTriangleWarp(
          mirrorCtx, this.uploadedImage,
          ...tri.src,
          ...flippedDst
        );
      });

      mirrorCtx.restore();
      this.ctx.drawImage(mirrorCanvas, 0, 0, width, height);
      this.currentImageData = this.ctx.getImageData(0, 0, width, height);
    }

    _variantIdChanged({ data: { event }}) {
      const orientationHandle = document.querySelector('[data-option-handle="orientation"] input:checked');
      const orientationLowerCase = orientationHandle.value.toLowerCase();
      const selectedBorder = PUB_SUB_BORDER_OPTIONS.find(border => border.title.value === event.target.value); 
      
      if(this.borderOptionsLabel && selectedBorder) {
        this.borderOptionsLabel.innerHTML = `<p><strong><span class="step-name">Step ${this.borderOptionsLabel.dataset.step}:</span> Border Options: </strong>${selectedBorder.title.value}</p>`;
        this.borderOptionProperty.name = 'properties[Border Option]';
        this.borderOptionProperty.value = selectedBorder.title.value;
      } 
      
      if (!selectedBorder || !this.dataset.imageSrc.includes('border-wrap') || !this.dataset.imageSrc.includes(orientationLowerCase)) return;
      
      this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
      
      if (this.originalImageData) {
        this.ctx.putImageData(this.originalImageData, 0, 0);
      } else if (this.currentImageData) {
        this.ctx.putImageData(this.currentImageData, 0, 0);
      }
      
      const coords = this.getBorderCoordinates();
      if (!coords) {
        this.createCanvas(orientationLowerCase);
        return;
      }
      
      if (selectedBorder.title.value === "Mirror Wrap") {
        if (this.uploadedImage) {
          this.addMirrorEffect(orientationLowerCase);
        } else {
          this.ctx.fillStyle = 'rgba(0, 0, 0, 0.1)';
          this.ctx.beginPath();
          this.ctx.moveTo(coords.topLeft.x, coords.topLeft.y);
          this.ctx.lineTo(coords.topRight.x, coords.topRight.y);
          this.ctx.lineTo(coords.bottomRight.x, coords.bottomRight.y);
          this.ctx.lineTo(coords.bottomLeft.x, coords.bottomLeft.y);
          this.ctx.closePath();
          this.ctx.fill();
        }
      } else {
        this.ctx.fillStyle = selectedBorder.color.value;
        this.ctx.beginPath();
        this.ctx.moveTo(coords.topLeft.x, coords.topLeft.y);
        this.ctx.lineTo(coords.topRight.x, coords.topRight.y);
        this.ctx.lineTo(coords.bottomRight.x, coords.bottomRight.y);
        this.ctx.lineTo(coords.bottomLeft.x, coords.bottomLeft.y);
        this.ctx.closePath();
        this.ctx.fill();
      }
    }

    createCanvas(orientation) {
      if(!this.dataset.imageSrc.includes(orientation)) return;
      
      const { width, height } = this.canvas;
      this.ctx.clearRect(0, 0, width, height); 
      
      const templateImage = new Image();
      templateImage.crossOrigin = "anonymous";
      templateImage.src = this.dataset.imageSrc;

      templateImage.onload = () => {
        const maskCanvas = document.createElement('canvas');
        maskCanvas.width = width;
        maskCanvas.height = height;
        const maskCtx = maskCanvas.getContext('2d', { willReadFrequently: true });
        
        maskCtx.drawImage(templateImage, 0, 0, width, height);
        const maskData = maskCtx.getImageData(0, 0, width, height);
        const maskPixels = maskData.data;

        let minX = width, minY = height, maxX = 0, maxY = 0;

        for (let y = 0; y < height; y++) {
          for (let x = 0; x < width; x++) {
            const idx = (y * width + x) * 4 + 3;
            const alpha = maskPixels[idx];

            if (alpha < 10) {
              if (x < minX) minX = x;
              if (x > maxX) maxX = x;
              if (y < minY) minY = y;
              if (y > maxY) maxY = y;
            }
          }
        }

        this.imageBounds = { minX, maxX, minY, maxY };
        
        if (minX >= maxX || minY >= maxY) {
          this.ctx.drawImage(templateImage, 0, 0, width, height);
          return;
        }
      };
    }
  }

  customElements.define('image-canvas-simulation', ImageCanvasSimulation);
}